import { Component, DOCUMENT, Inject, Injector, ViewEncapsulation } from '@angular/core';

import { RouterLink } from '@angular/router';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';




@Component({
    templateUrl: './theme11-brand.component.html',
    selector: 'theme11-brand',
    encapsulation: ViewEncapsulation.None,
    imports: [RouterLink]
})
export class Theme11BrandComponent extends AppComponentBase {

    defaultLogo = AppConsts.appBaseUrl +'/assets/common/images/upm-logo.svg';
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }

    clickTopbarToggle(): void {
        this.document.body.classList.toggle('m-topbar--on');
    }
}
